import styled from "styled-components";

export const ServiceCompWrapper = styled.div`
  background: rgba(256, 256, 256, 1);
  padding-top: 50px;
  @media (max-width: 1199px) {
    padding-top: 30px;
  }
  .service_heading {
    max-width: 1030px;
    margin: 0 auto 35px;
    p {
      font-weight: 500;
    }
  }
  .services_row {
    margin: -10px;
    align-items: stretch;
    .service_card_col {
      padding: 10px;
      width: 25%;
      height: auto;
      /* @media (max-width: 1199px) {
        width: 33.3%;
      } */
      @media (max-width: 1199px) {
        width: 50%;
      }
      @media (max-width: 479px) {
        width: 100%;
      }
    }
  }
`;

export const ViewAllWorksWrapper = styled.div`
  .viewWorks_card {
    padding: 100px 15px;
    min-height: 637px;
    position: relative;
    border-radius: 25px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: 1199px) {
      min-height: auto;
      padding: 90px 15px;
    }
    @media (max-width: 899px) {
      padding: 70px 15px;
      border-radius: 10px;
    }
    &::before {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      background: rgba(0, 0, 0, 0.7);
      z-index: 1;
    }
    .viewSection_bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .view_description_heading {
      position: relative;
      z-index: 2;
      color: rgba(256, 256, 256, 1);
      .upper_heading_wrap {
        max-width: 656px;
        margin: 0 auto 35px;
        h2 {
          color: rgba(256, 256, 256, 1);
        }
        @media (max-width: 1199px) {
          margin: 0 auto 20px;
        }
      }
      .view_works_btn {
        margin: 0 auto;
      }
    }
  }
`;
